import React from 'react';
import MaterialButton from '@material-ui/core/Button';

function getClassName(color, size="small") {
    let className = 'button';
    if (color) {
        className += ` ${color}`;
    }
    className += ` ${size}`;
    return className;
}

const Button = (props) => {
    return (
        <MaterialButton className={getClassName(props.color)} size="small" color="primary" variant="contained" {...props}>
            {props.children}
        </MaterialButton>
    );
};

export default Button;
